import React from 'react'
import { Search, X, ArrowRight } from 'lucide-react'
import { SearchResult } from '../../types/database'
import { highlightSearchResult } from '../../utils/search'

interface SearchResultsProps {
  results: SearchResult[]
  onResultClick: (result: SearchResult) => void
  onClose: () => void
  isVisible: boolean
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  results,
  onResultClick,
  onClose,
  isVisible
}) => {
  if (!isVisible || results.length === 0) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[80vh] mx-4">
        <div className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center space-x-2">
            <Search className="h-5 w-5 text-gray-500" />
            <h3 className="text-lg font-semibold">
              検索結果 ({results.length}件)
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="overflow-y-auto max-h-[calc(80vh-80px)]">
          {results.map((result, index) => (
            <div
              key={`${result.tableName}-${result.rowIndex}-${result.columnName}-${index}`}
              className="p-4 border-b hover:bg-gray-50 cursor-pointer"
              onClick={() => onResultClick(result)}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <span className="text-sm font-medium text-blue-600">
                      {result.tableName}
                    </span>
                    <ArrowRight className="h-3 w-3 text-gray-400" />
                    <span className="text-sm text-gray-600">
                      行 {result.rowIndex + 1}
                    </span>
                    <ArrowRight className="h-3 w-3 text-gray-400" />
                    <span className="text-sm text-gray-600">
                      {result.columnName}
                    </span>
                  </div>
                  <div 
                    className="text-sm text-gray-800"
                    dangerouslySetInnerHTML={{
                      __html: highlightSearchResult(String(result.value), '検索クエリ', false)
                    }}
                  />
                </div>
                <div className="ml-4">
                  <span className={`px-2 py-1 text-xs rounded-full ${
                    result.matchType === 'exact' 
                      ? 'bg-green-100 text-green-800'
                      : result.matchType === 'regex'
                      ? 'bg-purple-100 text-purple-800'
                      : 'bg-blue-100 text-blue-800'
                  }`}>
                    {result.matchType === 'exact' ? '完全一致' :
                     result.matchType === 'regex' ? '正規表現' : '部分一致'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="p-4 border-t bg-gray-50">
          <p className="text-sm text-gray-600">
            検索結果をクリックすると、該当するセルに移動します
          </p>
        </div>
      </div>
    </div>
  )
} 